var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-banner',[_c('p',[_vm._v("Help us make this feature even better!")]),_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noreferrer"}},[_c('ui-button',{attrs:{"color":"white"}},[_vm._v("Provide Feedback")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }